import { useStrings } from "@1js/localization-components";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import * as React from "react";
import {
  RemoveFromWorkgroupCancelButtonLabel,
  RemoveFromWorkgroupMessage,
  RemoveFromWorkgroupRemoveButtonLabel,
  RemoveFromWorkgroupTitle,
} from "./RemoveFromWorkgroupDialog.strings";

export type RemoveFromWorkgroupDialogProps = {
  isOpen: boolean;
  onClose: (isClosedByCustomer: boolean) => void;
  onRemove: () => void;
};

export const RemoveFromWorkgroupDialog: React.FC<
  RemoveFromWorkgroupDialogProps
> = ({ isOpen, onClose, onRemove }) => {
  const handleRemove = React.useCallback(() => {
    onRemove();
    onClose(false);
  }, [onClose, onRemove]);

  const handleClose = React.useCallback(() => {
    onClose(true);
  }, [onClose]);

  const localizations = useStrings({
    RemoveFromWorkgroupTitle,
    RemoveFromWorkgroupMessage,
    RemoveFromWorkgroupRemoveButtonLabel,
    RemoveFromWorkgroupCancelButtonLabel,
  });

  return (
    <Dialog open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{localizations.RemoveFromWorkgroupTitle()}</DialogTitle>
          <DialogContent>
            {localizations.RemoveFromWorkgroupMessage()}
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={handleRemove}>
              {localizations.RemoveFromWorkgroupRemoveButtonLabel()}
            </Button>
            <Button appearance="secondary" onClick={handleClose}>
              {localizations.RemoveFromWorkgroupCancelButtonLabel()}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
